import React from "react";
import { Table } from "antd";
import AntdTableScrollXaxisTop from "antd-table-scroll-xaxis-top";

import styles from "./TabelaRelatorioAluno.module.scss";

const gerarColunas = disciplinas => {
    if (!disciplinas || disciplinas.length === 0) return [];

    const colunasBase = [
        {
            title: "Disciplinas",
            dataIndex: "disciplina",
            key: "disciplina",
            align: "center",
            width: 350
        }
    ];

    const avaliacaoTitulos = [...disciplinas[0].avaliacoes.map(av => av.nome)];

    const colunasAvaliacao = avaliacaoTitulos.map((nome, index) => ({
        title: nome,
        dataIndex: `${nome}_${index}`,
        key: `${nome}_${index}`,
        align: "center",
        width: 120
    }));

    return [
        ...colunasBase,
        ...colunasAvaliacao,
        {
            title: "Estado",
            dataIndex: "estado",
            key: "estado",
            align: "center",
            width: 120
        }
    ];
};

const transformarDisciplinasParaDataSource = (disciplinas, colunas) => {
    const colunasAvaliacao = colunas.filter(col => col.dataIndex !== "disciplina" && col.dataIndex !== "estado");

    return disciplinas.map((disciplina, index) => {
        let linha = {
            key: index,
            disciplina: disciplina.disciplina
        };

        let media = null;
        let tempAvaliacoes = [...disciplina.avaliacoes];

        colunasAvaliacao.forEach(coluna => {
            const nomeOriginal = coluna.title;
            const avaIndex = tempAvaliacoes.findIndex(
                av => av.nome.replace(/\s+/g, "").toLowerCase() === nomeOriginal.replace(/\s+/g, "").toLowerCase()
            );

            if (avaIndex !== -1) {
                const ava = tempAvaliacoes[avaIndex];
                if (ava.nome === "Média Bimestral" || ava.nome === "Média Anual") {
                    media = ava?.nota?.replace(",", ".");
                    linha[coluna.dataIndex] = media || "-";
                } else {
                    linha[coluna.dataIndex] = ava.nota || "-";
                }

                tempAvaliacoes = tempAvaliacoes.filter((_, i) => i !== avaIndex);
            } else {
                linha[coluna.dataIndex] = "-";
            }
        });

        linha.estado = !isNaN(Number(media)) ? (
            <div className={`${styles.fundoCelula} ${media >= 6 ? styles.aprovado : styles.reprovado}`}>{media >= 6 ? "Aprovado" : "Reprovado"}</div>
        ) : (
            "-"
        );

        return linha;
    });
};

const TabelaRelatorioAluno = ({ disciplinas }) => {
    const colunas = gerarColunas(disciplinas);
    const dataSource = transformarDisciplinasParaDataSource(disciplinas, colunas);

    return (
        <AntdTableScrollXaxisTop>
            <Table className={styles.tabela} columns={colunas} dataSource={dataSource} bordered pagination={false} />
        </AntdTableScrollXaxisTop>
    );
};

export default TabelaRelatorioAluno;
